<template>
    <div class="gift-cards">
        <div class="row justify-content-md-center">
            <div class="col-md-8 col-lg-6">
                <div class="form-row mb-3 justify-content-md-center">
                    <div
                        class="btn-group btn-group-sm m-auto"
                        role="group"
                        aria-label="Select Location"
                        v-if="this.$screen.width > 580"
                    >
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="venue = 'All locations'"
                            :class="{ active: venue === 'All locations' }"
                        >
                            All locations
                        </button>
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="venue = 100"
                            :class="{ active: venue === 100 }"
                        >
                            Hoar Cross Hall
                        </button>
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="venue = 300"
                            :class="{ active: venue === 300 }"
                        >
                            Eden Hall
                        </button>
                    </div>
                    <select
                        v-if="this.$screen.width < 580"
                        class="form-control"
                        id="venue"
                        v-model.number="venue"
                    >
                        <option value="All locations">All locations</option>
                        <option value="100">Hoar Cross Hall</option>
                        <option value="300">Eden Hall</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-for="cards in filteredGC" class="row">
            <div class="col-12">
                <h3 class="archive-card__categories">{{ cards.category }}</h3>
            </div>
            <div
                v-for="card in cards.cards"
                class="col-md-6 col-lg-4"
                v-if="cards.cards"
            >
                <div class="archive-card mb-0">
                    <div
                        class="archive-card__badge"
                        v-if="card.badges !== null && card.badges.bestseller"
                    >
                        <img
                            class="img-fluid"
                            src="/img/bestseller.webp"
                            loading="lazy"
                            alt="Bestseller"
                        />
                    </div>
                    <div
                        class="archive-card__badge"
                        v-if="card.badges !== null && card.badges.most_loved"
                    >
                        <img
                            class="img-fluid"
                            src="/img/most-loved.webp"
                            loading="lazy"
                            alt="most loved"
                        />
                    </div>
                    <div
                        class="archive-card__badge"
                        v-if="card.badges !== null && card.badges.black_friday"
                    >
                        <img
                            class="img-fluid"
                            src="/img/black_friday.webp"
                            loading="lazy"
                            alt="black friday"
                        />
                    </div>
                    <LazyImage
                        :key="card.image"
                        :link="book + '/experience/gift-cards/' + card.slug"
                        :imageSrc="card.image"
                        :title="card.title"
                        class="archive-card__image"
                    />
                    <div class="archive-card__body">
                        <h2>
                            <a
                                :href="
                                    book + '/experience/gift-cards/' + card.slug
                                "
                                >{{ card.title }}</a
                            >
                        </h2>
                        <h5 class="archive-card__location">
                            {{ card.location }}
                        </h5>
                        <div
                            class="archive-card__description"
                            v-html="card.thumbnail_description"
                        ></div>
                        <span class="archive-card__price">
                            from &pound;{{ card.from_price }}
                        </span>
                        <a
                            :href="book + '/experience/gift-cards/' + card.slug"
                            class="btn btn-small btn-primary"
                            >Buy Now</a
                        >
                    </div>
                </div>
            </div>
            <div class="col-12">
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
import LazyImage from "./LazyImage.vue";

export default {
    props: {
        api: {
            type: String,
        },
        book: {
            type: String,
        },
    },
    data() {
        return {
            venue: "All locations",
            locations: {
                100: "Hoar Cross Hall",
                300: "Eden Hall",
            },
            cards: [],
        };
    },

    components: {
        LazyImage,
    },

    mounted() {
        this.getFeed();
    },

    computed: {
        filteredGC() {
            if (!this.cards.length) return [];

            let filteredCards = this.cards.filter((card) => {
                const shouldShow = (
                    this.venue === "All locations" ||
                    card.location === this.locations[this.venue]
                );
                console.log('Card:', card.title, 'Location:', card.location, 'Expected:', this.locations[this.venue], 'Show:', shouldShow);
                return shouldShow;
            });

            let groupedCards = _.groupBy(filteredCards, "category");

            let orderedCategories = Object.keys(groupedCards).map((key) => ({
                category: key,
                cards: groupedCards[key],
            }));

            let mostPopularIndex = orderedCategories.findIndex(
                (c) => c.category === "Most Popular"
            );
            if (mostPopularIndex !== -1) {
                let mostPopular = orderedCategories.splice(
                    mostPopularIndex,
                    1
                )[0];
                orderedCategories.unshift(mostPopular);
            }

            return orderedCategories;
        },
    },

    methods: {
        getFeed() {
            var self = this;
            self.cards = [];
            var promises = [];

            // If "All locations" is selected, fetch from all venues
            if (self.venue === "All locations") {
                _.each(self.locations, function (loc, k) {
                    promises.push(
                        axios.post(
                            "https://api.baronseden.com/api/gift-cards/categories",
                            {
                                venue_id: k,
                            }
                        )
                    );
                });
            } else {
                // Only fetch from the selected venue
                promises.push(
                    axios.post(
                        "https://api.baronseden.com/api/gift-cards/categories",
                        {
                            venue_id: parseInt(self.venue),
                        }
                    )
                );
            }

            Promise.all(promises).then((responses) => {
                _.each(responses, function (response) {
                    var venue_id = JSON.parse(response.config.data).venue_id;
                    var location = self.locations[venue_id];

                    _.each(response.data.data, function (cat) {
                        _.each(cat.gift_cards, function (gc) {
                            gc.location = location;
                            gc.category = cat.title;
                            gc.category_slug = cat.slug;
                            gc.from_price =
                                _.minBy(gc.gift_card_options, "price").price ||
                                null;
                            self.cards.push(gc);
                        });
                    });
                });
            });
        },
    },

    watch: {
        venue() {
            this.getFeed();
        },
    },
};
</script>

<style lang="scss" scoped>
.gift-cards {
    .col-md-6 {
        margin-bottom: 40px;

        .archive-card {
            height: 100%;

            .btn {
                position: absolute;
                bottom: 0;
                right: 10px;
                font-size: 12px;
                padding: 2px 10px;

                @media (max-width: 767px) {
                    position: relative;
                    bottom: auto;
                    right: auto;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
